export default __webpack_public_path__ + "static/media/product.adcad6a7.png";